import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3g8677jhp: FaireProductEntity = {
  token: "p_g3g8677jhp",
  type: "product",
  name: "Full Zip Up Long Sleeve Pockets Hoodie",
  brandToken: "b_ssnpnu4tp4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/577ef621e17127a7a4bd6fca62ce24f2195ca864280fca49304347a19471b598.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f5fd7dce923be14433eb0ecdb7b0294b0ef9cd29d150bd1947af355c5880f33.jpeg",
  ],
  priceDollars: 25.63,
  description:
    "Attention: Some colors displayed on the website may not be available for selection, but we can customize them to you. If you have a specific color in mind, we can customize that as well. For more information, please contact our customer service team.\nMaterial: 100% Polyester\nFeatures: Full Zip Up Long Sleeve Pockets Hoodie\nOccasion: Casual/Daily/Outdoor/Vacation/Holiday/School/Going Out.\nStyle # EOHD510282",
  tags: [],
  msrpDollars: 51.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:40.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
